import ColorWheelPicker from './ColorWheelPicker';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { useThemeColor } from '@/hooks/useThemeColor';
import {
  themeColorCombo,
  themeColorComboActive,
  themeColorComboDot,
  themeColorComboDots,
  themeColorComboLabel,
  themeColorComboTag,
  themeColorCombos,
  themeColorFooter,
  themeColorReset,
  themeColorSection,
  themeColorSectionLabel,
  themeColorSwatch,
  themeColorSwatchActive,
  themeColorSwatches,
} from './theme-color-layout';

const ThemeColorPicker = () => {
  const {
    baseColor,
    combinationId,
    setBaseColor,
    applyCombination,
    reset,
    baseSwatches,
    combinations,
    effectiveAccent,
  } = useThemeColor();

  const isCustomActive = Boolean(baseColor) && !combinationId;

  return (
    <div>
      <div className="mb-3 flex items-center gap-2.5 rounded-[8px] border border-solid border-[var(--inv-border-soft)] bg-[var(--inv-surface-muted)] px-2.5 py-2">
        <span
          className="h-6 w-6 shrink-0 rounded-full shadow-[inset_0_0_0_1px_rgba(0,0,0,0.08)]"
          style={{ backgroundColor: effectiveAccent }}
          aria-hidden="true"
        />
        <div className="min-w-0">
          <p className="m-0 text-[0.65rem] font-semibold uppercase tracking-[0.08em] text-[var(--inv-text-muted)]">
            Selected
          </p>
          <p className="m-0 truncate font-mono text-[0.8125rem] text-[var(--inv-text)]">
            {effectiveAccent.toUpperCase()}
          </p>
        </div>
      </div>

      <div className={cn(themeColorSection, 'mt-0')}>
        <div className={themeColorSectionLabel}>Color wheel</div>
        <ColorWheelPicker
          value={baseColor ?? effectiveAccent}
          onChange={hex => setBaseColor(hex)}
        />
      </div>

      <div className={themeColorSection}>
        <div className={themeColorSectionLabel}>Base color</div>
        <div className={themeColorSwatches}>
          {baseSwatches.map(swatch => {
            const isActive =
              isCustomActive &&
              baseColor?.toLowerCase() === swatch.color.toLowerCase();
            return (
              <Button
                key={swatch.id}
                type="button"
                variant="ghost"
                title={swatch.label}
                aria-label={swatch.label}
                className={cn(
                  themeColorSwatch,
                  isActive && themeColorSwatchActive,
                  'h-auto',
                )}
                style={{ backgroundColor: swatch.color }}
                onClick={() => setBaseColor(swatch.color)}
              />
            );
          })}
        </div>
      </div>

      <div className={themeColorFooter}>
        <Button
          type="button"
          variant="ghost"
          className={cn(themeColorReset, 'h-auto')}
          onClick={reset}>
          Reset to default
        </Button>
      </div>
    </div>
  );
};

export default ThemeColorPicker;
